import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  EarningsInsightFilterResponse,
  earningsInsights,
  EarningsInsightsFilterRequest,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_INSIGHTS_FILTER = 'QUERY_KEY_EARNINGS_INSIGHTS_FILTER';

export const useEarningsInsightsFilter = ({
  body = {},
  isEnabled = true,
}: {
  body?: EarningsInsightsFilterRequest;
  isEnabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHTS_FILTER, body],
    queryFn: ({ signal }) => {
      const { path, schema } = earningsInsights.postEarningsInsightFilter;
      return wretchRequest<EarningsInsightFilterResponse>(path, {
        method: 'post',
        body,
        schema,
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: isEnabled,
  });
};
